import React from "react";
import "./Footer.css";
import logo from "../../Assets/logo.png";
import paymentIcon from "../../Assets/paymentIcon.png";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import { Link } from "react-router-dom";

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };



  return (
    <>
    <footer class="footer">
        <div class="footer-container">
            <div class="footer-section">
                <h1 class="footer-logo">Eadaad<span class="dot">.</span></h1>
                <p class="footer-text">
                Eadaad is committed to delivering high-quality products with authenticity and excellence.
                 We focus on craftsmanship and durability to ensure the best experience. Quality is our promise in every detail.
                </p>
            </div>

            <div class="footer-section">
                <h2 class="footer-heading">COMPANY</h2>
                <ul class="footer-links">
                <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/shop" onClick={scrollToTop}>Shop</Link></li>
              <li><Link to="/about" onClick={scrollToTop}>About us</Link></li>
              <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
                </ul>
            </div>

            <div class="footer-section">
                <h2 class="footer-heading">GET IN TOUCH</h2>
                <ul class="footer-links">
                    <li>+1-000-000-0000</li>
                    <li><a href="mailto:mohammadhussnain47@gmail.com">mohammadhussnain47@gmail.com</a></li>
                   
                </ul>
                <div className="social_links">
               <FaFacebookF /> 
              <FaXTwitter />
              <FaInstagram />
              <FaYoutube />
              <FaPinterest />
            </div>
            </div>
        </div>

        <div class="footer-copyright">
            Copyright 2025 @  - All Rights Reserved.
        </div>
    </footer>
  
    </>
  );
};

export default Footer;
